// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-wrapper {
  background-color: #F9F9F9;
  padding-top: 100px;
  padding-bottom: 24px;
  font-family: "Proxima Nova", sans-serif;
}
.footer-wrapper footer {
  border-radius: 24px;
  background-color: white;
  padding: 50px 50px 20px 50px;
  display: flex;
  flex-direction: column;
}
.footer-wrapper footer .content {
  display: flex;
}
.footer-wrapper footer .content > div {
  flex: 1 1;
}
.footer-wrapper footer .content .footer-links {
  display: flex;
  column-gap: 50px;
  flex: 2 1;
  justify-content: center;
}
.footer-wrapper footer .content .footer-links ul {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}
.footer-wrapper footer .content .footer-links ul li {
  font-size: 10px;
  color: var(--secondary-color-1);
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.footer-wrapper footer .content .footer-links ul li:hover {
  color: var(--primary-color-1);
}
.footer-wrapper footer .content .footer-links ul li.header {
  cursor: default;
  padding-bottom: 10px;
  font-weight: 700;
  font-size: 14px;
}
.footer-wrapper footer .content .footer-links ul li.header:hover {
  color: inherit;
}
.footer-wrapper footer .content .subscribe {
  align-self: flex-start;
  display: flex;
  justify-content: flex-end;
}
.footer-wrapper footer .content .subscribe > div {
  width: -moz-fit-content;
  width: fit-content;
}
.footer-wrapper footer .sub-content {
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--secondary-color-1);
  padding: 32px 50px;
  margin-top: 70px;
}
.footer-wrapper footer .sub-content .copyright {
  margin: 0;
  font-size: 10px;
  font-weight: 600;
  color: white;
}
.footer-wrapper footer .sub-content .social-links {
  display: flex;
  align-items: center;
  column-gap: 30px;
}

@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .footer-wrapper footer .content {
    align-items: center;
    row-gap: 30px;
    flex-direction: column;
  }
  .footer-wrapper footer .content .footer-links {
    order: 3;
  }
  .footer-wrapper footer .content .subscribe {
    align-self: center;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .footer-wrapper footer {
    padding: 30px;
  }
  .footer-wrapper footer .content {
    align-items: center;
    row-gap: 30px;
    flex-direction: column;
  }
  .footer-wrapper footer .content .footer-links {
    order: 3;
    flex-wrap: wrap;
    column-gap: 0;
    row-gap: 20px;
  }
  .footer-wrapper footer .content .footer-links ul {
    flex: 50% 1;
  }
  .footer-wrapper footer .content .subscribe {
    align-self: center;
    width: 100%;
  }
  .footer-wrapper footer .content .subscribe > div {
    width: 100%;
  }
  .footer-wrapper footer .sub-content {
    padding: 20px 43px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    row-gap: 30px;
  }
  .footer-wrapper footer .sub-content .copyright {
    text-align: center;
    order: 2;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/footer.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAGA;EACI,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,uCAAA;AAFJ;AAGI;EACI,mBAAA;EACA,uBAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;AADR;AAGQ;EACI,aAAA;AADZ;AAGY;EACI,SAAA;AADhB;AAIY;EACI,aAAA;EACA,gBAAA;EACA,SAAA;EACA,uBAAA;AAFhB;AAIgB;EACI,aAAA;EACA,sBAAA;EACA,aAAA;AAFpB;AAIoB;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;AAFxB;AAIwB;EACI,6BAAA;AAF5B;AAKwB;EACI,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;AAH5B;AAK4B;EACI,cAAA;AAHhC;AAUY;EACI,sBAAA;EACA,aAAA;EACA,yBAAA;AARhB;AAUgB;EACI,uBAAA;EAAA,kBAAA;AARpB;AAYQ;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;AAVZ;AAWY;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAThB;AAWY;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AAThB;;AClEY;EDoFA;IACI,mBAAA;IACA,aAAA;IACA,sBAAA;EAdd;EAgBc;IACI,QAAA;EAdlB;EAiBc;IACI,kBAAA;EAflB;AACF;ACvFY;ED8GJ;IACI,aAAA;EApBV;EAsBU;IACI,mBAAA;IACA,aAAA;IACA,sBAAA;EApBd;EAsBc;IACI,QAAA;IACA,eAAA;IACA,aAAA;IACA,aAAA;EApBlB;EAsBkB;IACI,WAAA;EApBtB;EAwBc;IACI,kBAAA;IACA,WAAA;EAtBlB;EAwBkB;IACI,WAAA;EAtBtB;EA0BU;IACI,kBAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;IACA,aAAA;EAxBd;EAyBc;IACI,kBAAA;IACA,QAAA;EAvBlB;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n\r\n.footer-wrapper {\r\n    background-color: #F9F9F9;\r\n    padding-top: 100px;\r\n    padding-bottom: 24px;\r\n    font-family: 'Proxima Nova', sans-serif;\r\n    footer {\r\n        border-radius: 24px;\r\n        background-color: white;\r\n        padding: 50px 50px 20px 50px;\r\n        display: flex;\r\n        flex-direction: column;\r\n\r\n        .content {\r\n            display: flex;\r\n\r\n            >div {\r\n                flex: 1;\r\n            }\r\n\r\n            .footer-links {\r\n                display: flex;\r\n                column-gap: 50px;\r\n                flex: 2;\r\n                justify-content: center;\r\n\r\n                ul {\r\n                    display: flex;\r\n                    flex-direction: column;\r\n                    row-gap: 10px;\r\n\r\n                    li {\r\n                        font-size: 10px;\r\n                        color: var(--secondary-color-1);\r\n                        font-weight: 600;\r\n                        cursor: pointer;\r\n                        transition: .2s ease-in-out;\r\n\r\n                        &:hover {\r\n                            color: var(--primary-color-1);\r\n                        }\r\n\r\n                        &.header {\r\n                            cursor: default;\r\n                            padding-bottom: 10px;\r\n                            font-weight: 700;\r\n                            font-size: 14px;\r\n\r\n                            &:hover {\r\n                                color: inherit;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n            .subscribe {\r\n                align-self: flex-start;\r\n                display: flex;\r\n                justify-content: flex-end;\r\n\r\n                >div {\r\n                    width: fit-content;\r\n                }\r\n            }\r\n        }\r\n        .sub-content {\r\n            border-radius: 8px;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: space-between;\r\n            background-color: var(--secondary-color-1);\r\n            padding: 32px 50px;\r\n            margin-top: 70px;\r\n            .copyright {\r\n                margin: 0;\r\n                font-size: 10px;\r\n                font-weight: 600;\r\n                color: white;\r\n            }\r\n            .social-links {\r\n                display: flex;\r\n                align-items: center;\r\n                column-gap: 30px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@include media(tablet) {\r\n    .footer-wrapper {\r\n        footer {\r\n            .content {\r\n                align-items: center;\r\n                row-gap: 30px;\r\n                flex-direction: column;\r\n\r\n                .footer-links {\r\n                    order: 3;\r\n                }\r\n\r\n                .subscribe {\r\n                    align-self: center;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@include media(mobile) {\r\n    .footer-wrapper {\r\n        footer {\r\n            padding: 30px;\r\n\r\n            .content {\r\n                align-items: center;\r\n                row-gap: 30px;\r\n                flex-direction: column;\r\n\r\n                .footer-links {\r\n                    order: 3;\r\n                    flex-wrap: wrap;\r\n                    column-gap: 0;\r\n                    row-gap: 20px;\r\n\r\n                    ul {\r\n                        flex: 50%;\r\n                    }\r\n                }\r\n\r\n                .subscribe {\r\n                    align-self: center;\r\n                    width: 100%;\r\n\r\n                    >div {\r\n                        width: 100%;\r\n                    }\r\n                }\r\n            }\r\n            .sub-content {\r\n                padding: 20px 43px;\r\n                flex-direction: column;\r\n                align-items: center;\r\n                justify-content: center;\r\n                row-gap: 30px;\r\n                .copyright {\r\n                    text-align: center;\r\n                    order: 2;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
